import { Component, inject, OnInit, effect, HostBinding } from '@angular/core';
import { AdminMenuComponent } from '../admin-menu/admin-menu.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter } from 'rxjs';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-admin-page',
  imports: [
    AdminMenuComponent,
    RouterOutlet,
    BreadcrumbModule,
    ConfirmDialogModule,
  ],
  templateUrl: './admin-page.component.html',
})
export class AdminPageComponent implements OnInit {
  // h-dvh et non h-screen : le shell verrouille le scroll du document, donc une hauteur
  // supérieure au viewport visible (barres du navigateur déployées) serait irrattrapable.
  @HostBinding('class') hostClass = 'block h-dvh';

  router = inject(Router);
  breadcrumbService = inject(BreadcrumbService);
  breadcrumbItems: { label: string; routerLink: string }[] = [];

  // Design tokens for PrimeNG breadcrumb
  // Colors from tailwind.config.js: greyscale-400=#B1B5B1, primary-500=#527A6D
  breadcrumbTokens = {
    padding: '1rem',
    background: 'transparent',
    gap: '0.25rem',
    item: {
      color: '#B1B5B1',
      hoverColor: '#527A6D',
      gap: '0.25rem',
      icon: {
        color: '#B1B5B1',
        hoverColor: '#527A6D',
      },
    },
    separator: {
      color: '#B1B5B1',
    },
  };

  constructor() {
    // Re-render breadcrumb when custom labels change
    effect(() => {
      // Access the signal to track changes
      this.breadcrumbService.getLabel('');
      this.updateBreadcrumb();
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumb();
      });
    this.updateBreadcrumb(); // initial
  }

  updateBreadcrumb() {
    const urlSegments = this.router.url.split('/').filter(Boolean);
    this.breadcrumbItems = [];
    let path = '';
    urlSegments.forEach((segment) => {
      path += '/' + segment;
      // Check for custom label first, otherwise capitalize segment
      const customLabel = this.breadcrumbService.getLabel(segment);
      const label = customLabel || this.formatSegment(segment);
      this.breadcrumbItems.push({
        label,
        routerLink: path,
      });
    });
  }

  private formatSegment(segment: string): string {
    // Format known segments nicely
    const knownLabels: Record<string, string> = {
      admin: 'Admin',
      projects: 'Projects',
      company: 'Companies',
      user: 'Users',
      users: 'Users',
      contributions: 'Contributions',
      edit: 'Edit',
      create: 'Create',
      new: 'New',
    };
    return (
      knownLabels[segment.toLowerCase()] ||
      segment.charAt(0).toUpperCase() + segment.slice(1)
    );
  }
}
